import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { Button } from "semantic-ui-react";
import { FilterContext } from "../FilterContext";
import { initialHubSpotLinkedFilter } from "./FilterTypes/HubSpotLinkedFilterType";

interface HubSpotLinkedFilterProps {
  title?: string
}

const HubSpotLinkedFilter = (props: HubSpotLinkedFilterProps) => {
  const title = props.title || "HubSpot";
  const onlyNotLinkedLabel = "Only not linked";
  const onlyLinkedLabel = "Only linked";

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);

  register("hubSpotLinked", {
    getTitle: () => title,
    renderSelection: (filter) => <>
      {filter.linked === "onlyLinked" ? onlyLinkedLabel : undefined}
      {filter.linked === "onlyNotLinked" ? onlyNotLinkedLabel : undefined}
    </>,
    hasValue: (filter) => filter.linked !== "noFilter",
    reset: () => ({
      linked: "noFilter"
    }),
    areEqual: (a, b) => a.linked === b.linked
  });

  useEffect(() => {
    setInitialValue("hubSpotLinked", initialHubSpotLinkedFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [linked, setLinked] = React.useState<server.dto.LinkedFilterSettings>(initialHubSpotLinkedFilter.linked);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setLinked(getValue("hubSpotLinked").linked);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("hubSpotLinked", { linked: linked });
    setPopupOpen(false);
  };

  const options: Array<{ value: server.dto.LinkedFilterSettings, label: string }> = [
    { value: "onlyLinked", label: onlyLinkedLabel },
    { value: "onlyNotLinked", label: onlyNotLinkedLabel }
  ];
  type Option = typeof options[number];

  const onChange = (option: Option) => {
    setLinked(option.value);
    setValue("hubSpotLinked", { linked: option.value });
    onPopupClose();
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<form onSubmit={onApply}>
        <div className="margin-bottom">
          <SelectableList
            noSearch
            noScrolling
            items={options}
            selectedItems={[options.find(v => v.value === linked)].filter(Boolean)}
            onItemToggled={onChange}
            getId={opt => opt.value.toString()}
            getName={opt => opt.label}
          />
        </div>

        <Button fluid type="submit" primary >
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default HubSpotLinkedFilter;